import {
	AutomationPropagateMetadataField,
	AutomationPropagateMetadataRelationship,
} from '../../api/types/models/automation/automationPropagateMetadata';

export const propagateMetadataOptions: {
	label: string;
	value: string;
}[] = [
	{
		label: 'Description',
		value: AutomationPropagateMetadataField.DESCRIPTION,
	},
	{
		label: 'Documentation',
		value: AutomationPropagateMetadataField.DOCUMENTATION,
	},
	{
		label: 'Verification',
		value: AutomationPropagateMetadataField.VERIFICATION,
	},
	{
		label: 'Governance',
		value: AutomationPropagateMetadataField.GOVERNANCE,
	},
	{
		label: 'Tags',
		value: AutomationPropagateMetadataField.TAGS,
	},
	{
		label: 'Collections',
		value: AutomationPropagateMetadataField.COLLECTIONS,
	},
	{
		label: 'Owners',
		value: AutomationPropagateMetadataField.OWNERS,
	},
];

export const propagateToOptions: {
	label: string;
	value: AutomationPropagateMetadataRelationship;
}[] = [
	{
		label: 'Children',
		value: AutomationPropagateMetadataRelationship.CHILDREN,
	},
	{
		label: 'Parents',
		value: AutomationPropagateMetadataRelationship.PARENT,
	},
	{
		label: 'Upstream resources',
		value: AutomationPropagateMetadataRelationship.LINEAGE_UP,
	},
	{
		label: 'Downstream resources',
		value: AutomationPropagateMetadataRelationship.LINEAGE_DOWN,
	},
	{
		label: 'Resources with same title',
		value: AutomationPropagateMetadataRelationship.EXACT_NAME,
	},
];

export const propagateLevelOptions: {
	label: string;
	value: string;
}[] = [
	{
		label: '1 level',
		value: '1',
	},
	{
		label: '2 levels',
		value: '2',
	},
	{
		label: '3 levels',
		value: '3',
	},
	{
		label: '4 levels',
		value: '4',
	},
];
